module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-7.e5d2494c.png";